import React from 'react';
import { createPortal } from 'react-dom';
import { Box } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import QuizIcon from '@mui/icons-material/Quiz';
import GradingIcon from '@mui/icons-material/Grading';
import EditNoteIcon from '@mui/icons-material/EditNote';
import SchoolIcon from '@mui/icons-material/School';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CalculateIcon from '@mui/icons-material/Calculate';
import ScienceIcon from '@mui/icons-material/Science';
import FunctionsIcon from '@mui/icons-material/Functions';
import BiotechIcon from '@mui/icons-material/Biotech';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

export default function BackgroundIcons() {
  const backgroundContent = (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          zIndex: 0,
          overflow: 'hidden'
        }}
      >
        {/* Assignment Icon */}
        <Box sx={{
          position: 'absolute',
          top: '10%',
          left: '5%',
          animation: 'float1 20s ease-in-out infinite'
        }}>
          <AssignmentIcon sx={{
            fontSize: { xs: 20, md: 32 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(-15deg)'
          }} />
        </Box>
        
        {/* Functions Icon - Math Equations */}
        <Box sx={{
          position: 'absolute',
          top: '25%',
          right: '8%',
          animation: 'float2 25s ease-in-out infinite',
          animationDelay: '2s'
        }}>
          <FunctionsIcon sx={{
            fontSize: { xs: 22, md: 34 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(20deg)'
          }} />
        </Box>
        
        {/* Quiz Icon */}
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '3%',
          animation: 'float3 22s ease-in-out infinite',
          animationDelay: '4s'
        }}>
          <QuizIcon sx={{
            fontSize: { xs: 22, md: 34 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(10deg)'
          }} />
        </Box>
        
        {/* Grading Icon */}
        <Box sx={{
          position: 'absolute',
          top: '65%',
          right: '5%',
          animation: 'float4 18s ease-in-out infinite',
          animationDelay: '1s'
        }}>
          <GradingIcon sx={{
            fontSize: { xs: 24, md: 36 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(-25deg)'
          }} />
        </Box>
        
        {/* Edit Note Icon */}
        <Box sx={{
          position: 'absolute',
          top: '80%',
          left: '10%',
          animation: 'float5 24s ease-in-out infinite',
          animationDelay: '3s'
        }}>
          <EditNoteIcon sx={{
            fontSize: { xs: 18, md: 28 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(15deg)'
          }} />
        </Box>
        
        {/* Biotech Icon - Chemistry */}
        <Box sx={{
          position: 'absolute',
          top: '15%',
          right: '15%',
          animation: 'float6 26s ease-in-out infinite',
          animationDelay: '5s'
        }}>
          <BiotechIcon sx={{
            fontSize: { xs: 20, md: 32 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(-10deg)'
          }} />
        </Box>
        
        {/* School Icon */}
        <Box sx={{
          position: 'absolute',
          top: '40%',
          right: '12%',
          animation: 'float7 21s ease-in-out infinite',
          animationDelay: '2.5s'
        }}>
          <SchoolIcon sx={{
            fontSize: { xs: 24, md: 38 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(-20deg)'
          }} />
        </Box>
        
        {/* Check Circle Icon */}
        <Box sx={{
          position: 'absolute',
          top: '75%',
          right: '20%',
          animation: 'float8 23s ease-in-out infinite',
          animationDelay: '3.5s'
        }}>
          <CheckCircleOutlineIcon sx={{
            fontSize: { xs: 20, md: 32 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(25deg)'
          }} />
        </Box>
        
        {/* Analytics Icon - Aptitude Analysis */}
        <Box sx={{
          position: 'absolute',
          top: '5%',
          left: '15%',
          animation: 'float9 19s ease-in-out infinite',
          animationDelay: '1.5s'
        }}>
          <AnalyticsIcon sx={{
            fontSize: { xs: 20, md: 32 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(-12deg)'
          }} />
        </Box>
        
        {/* Trending Up Icon - Growth/Aptitude */}
        <Box sx={{
          position: 'absolute',
          top: '30%',
          left: '12%',
          animation: 'float10 24s ease-in-out infinite',
          animationDelay: '3s'
        }}>
          <TrendingUpIcon sx={{
            fontSize: { xs: 22, md: 34 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(18deg)'
          }} />
        </Box>
        
        {/* Calculate Icon */}
        <Box sx={{
          position: 'absolute',
          top: '55%',
          right: '10%',
          animation: 'float11 21s ease-in-out infinite',
          animationDelay: '2s'
        }}>
          <CalculateIcon sx={{
            fontSize: { xs: 24, md: 36 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(-18deg)'
          }} />
        </Box>
        
        {/* Science Icon */}
        <Box sx={{
          position: 'absolute',
          top: '20%',
          left: '8%',
          animation: 'float12 23s ease-in-out infinite',
          animationDelay: '4.5s'
        }}>
          <ScienceIcon sx={{
            fontSize: { xs: 21, md: 33 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(22deg)'
          }} />
        </Box>
        
        {/* Functions Icon - More Math */}
        <Box sx={{
          position: 'absolute',
          top: '70%',
          left: '7%',
          animation: 'float13 20s ease-in-out infinite',
          animationDelay: '2.5s'
        }}>
          <FunctionsIcon sx={{
            fontSize: { xs: 19, md: 31 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(-22deg)'
          }} />
        </Box>
        
        {/* Biotech Icon - More Chemistry */}
        <Box sx={{
          position: 'absolute',
          top: '35%',
          right: '18%',
          animation: 'float14 25s ease-in-out infinite',
          animationDelay: '1s'
        }}>
          <BiotechIcon sx={{
            fontSize: { xs: 23, md: 35 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(14deg)'
          }} />
        </Box>
        
        {/* Emoji Events Icon - Achievement/Success */}
        <Box sx={{
          position: 'absolute',
          top: '60%',
          left: '18%',
          animation: 'float15 22s ease-in-out infinite',
          animationDelay: '3.5s'
        }}>
          <EmojiEventsIcon sx={{
            fontSize: { xs: 20, md: 32 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(-16deg)'
          }} />
        </Box>
        
        {/* Calculate Icon - More Calculator */}
        <Box sx={{
          position: 'absolute',
          top: '85%',
          right: '12%',
          animation: 'float16 26s ease-in-out infinite',
          animationDelay: '4s'
        }}>
          <CalculateIcon sx={{
            fontSize: { xs: 20, md: 32 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(19deg)'
          }} />
        </Box>
        
        {/* School Icon - More Graduation Cap */}
        <Box sx={{
          position: 'absolute',
          top: '45%',
          left: '20%',
          animation: 'float17 18s ease-in-out infinite',
          animationDelay: '5.5s'
        }}>
          <SchoolIcon sx={{
            fontSize: { xs: 20, md: 32 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(-8deg)'
          }} />
        </Box>
        
        {/* Analytics Icon - More Aptitude */}
        <Box sx={{
          position: 'absolute',
          top: '12%',
          right: '25%',
          animation: 'float18 24s ease-in-out infinite',
          animationDelay: '6s'
        }}>
          <AnalyticsIcon sx={{
            fontSize: { xs: 20, md: 32 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(12deg)'
          }} />
        </Box>
        
        {/* Science Icon - More Chemistry */}
        <Box sx={{
          position: 'absolute',
          top: '90%',
          left: '25%',
          animation: 'float19 20s ease-in-out infinite',
          animationDelay: '1.8s'
        }}>
          <ScienceIcon sx={{
            fontSize: { xs: 21, md: 33 },
            color: 'rgba(18,82,166,0.12)',
            fontWeight: 'bold',
            transform: 'rotate(-14deg)'
          }} />
        </Box>
      </Box>
      
      {/* Add floating animation keyframes */}
      <style>{`
        @keyframes float1 {
          0%, 100% { transform: translateY(0px) rotate(-15deg); }
          50% { transform: translateY(-20px) rotate(-15deg); }
        }
        @keyframes float2 {
          0%, 100% { transform: translateY(0px) rotate(20deg); }
          50% { transform: translateY(-25px) rotate(20deg); }
        }
        @keyframes float3 {
          0%, 100% { transform: translateY(0px) rotate(10deg); }
          50% { transform: translateY(-18px) rotate(10deg); }
        }
        @keyframes float4 {
          0%, 100% { transform: translateY(0px) rotate(-25deg); }
          50% { transform: translateY(-22px) rotate(-25deg); }
        }
        @keyframes float5 {
          0%, 100% { transform: translateY(0px) rotate(15deg); }
          50% { transform: translateY(-19px) rotate(15deg); }
        }
        @keyframes float6 {
          0%, 100% { transform: translateY(0px) rotate(-10deg); }
          50% { transform: translateY(-21px) rotate(-10deg); }
        }
        @keyframes float7 {
          0%, 100% { transform: translateY(0px) rotate(-20deg); }
          50% { transform: translateY(-23px) rotate(-20deg); }
        }
        @keyframes float8 {
          0%, 100% { transform: translateY(0px) rotate(25deg); }
          50% { transform: translateY(-20px) rotate(25deg); }
        }
        @keyframes float9 {
          0%, 100% { transform: translateY(0px) rotate(-12deg); }
          50% { transform: translateY(-18px) rotate(-12deg); }
        }
        @keyframes float10 {
          0%, 100% { transform: translateY(0px) rotate(18deg); }
          50% { transform: translateY(-22px) rotate(18deg); }
        }
        @keyframes float11 {
          0%, 100% { transform: translateY(0px) rotate(-18deg); }
          50% { transform: translateY(-19px) rotate(-18deg); }
        }
        @keyframes float12 {
          0%, 100% { transform: translateY(0px) rotate(22deg); }
          50% { transform: translateY(-21px) rotate(22deg); }
        }
        @keyframes float13 {
          0%, 100% { transform: translateY(0px) rotate(-22deg); }
          50% { transform: translateY(-20px) rotate(-22deg); }
        }
        @keyframes float14 {
          0%, 100% { transform: translateY(0px) rotate(14deg); }
          50% { transform: translateY(-23px) rotate(14deg); }
        }
        @keyframes float15 {
          0%, 100% { transform: translateY(0px) rotate(-16deg); }
          50% { transform: translateY(-17px) rotate(-16deg); }
        }
        @keyframes float16 {
          0%, 100% { transform: translateY(0px) rotate(19deg); }
          50% { transform: translateY(-24px) rotate(19deg); }
        }
        @keyframes float17 {
          0%, 100% { transform: translateY(0px) rotate(-8deg); }
          50% { transform: translateY(-19px) rotate(-8deg); }
        }
        @keyframes float18 {
          0%, 100% { transform: translateY(0px) rotate(12deg); }
          50% { transform: translateY(-21px) rotate(12deg); }
        }
        @keyframes float19 {
          0%, 100% { transform: translateY(0px) rotate(-14deg); }
          50% { transform: translateY(-20px) rotate(-14deg); }
        }
      `}</style>
    </>
  );

  // Use portal to render at document body level for visibility across all pages
  if (typeof document !== 'undefined') {
    return createPortal(backgroundContent, document.body);
  }
  
  return backgroundContent;
}
